<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Wrestler 1</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId1" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <color-select-group :label="'Color 1'" :id="safeId('color1')" v-model="color1"
                          ></color-select-group>
      <div class="form-group form-row">
        <label :for="safeId('title1')" class="col-sm-4 col-form-label">Name 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title1')" v-model.lazy="title1">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('club1')" class="col-sm-4 col-form-label">Club 1</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('club1')" v-model.lazy="club1">
        </div>
      </div>
      <div class="form-group form-row" v-if="datasetId">
        <label :for="safeId('record')" class="col-sm-4 col-form-label">Wrestler 2</label>
        <div class="col-sm-8">
          <record-select :id="safeId('record')" v-model="recordId2" :dataset-id="datasetId"></record-select>
        </div>
      </div>
      <color-select-group :label="'Color 2'" :id="safeId('color2')" v-model="color2"
                          ></color-select-group>
      <div class="form-group form-row">
        <label :for="safeId('title2')" class="col-sm-4 col-form-label">Name 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title2')" v-model.lazy="title2">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('club2')" class="col-sm-4 col-form-label">Club 2</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('club2')" v-model.lazy="club2">
        </div>
      </div>
    </window-tab>
    <window-tab title="Data" icon="database">
      <div class="form-group form-row">
        <label :for="safeId('datasetId')" class="col-sm-4 col-form-label">Dataset</label>
        <div class="col-sm-8">
          <dataset-select :id="safeId('datasetId')" v-model="datasetId"></dataset-select>
        </div>
      </div>
      <div class="form-group form-row">
        <label class="col-sm-4 col-form-label">Fields</label>
        <div class="col-sm-8">
          <input type="text" readonly class="form-control-plaintext" :value="datasetColumns">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternColor')" class="col-sm-4 col-form-label">Color</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternColor')" v-model.lazy="patternColor">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternTitle')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternTitle')" v-model.lazy="patternTitle">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('patternClub')" class="col-sm-4 col-form-label">Club</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('patternClub')" v-model.lazy="patternClub">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :templateId="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapOverlayData, mapTemplateData } from '../../utils/index'

export default {
  name: 'swiss-wrestling-duel',
  mixins: [templateMixin],
  computed: {
    ...mapOverlayData(['color1', 'color2', 'title1', 'title2', 'club1', 'club2']),
    ...mapTemplateData(['datasetId', 'recordId1', 'recordId2']),
    ...mapTemplateData({
      /* eslint-disable no-template-curly-in-string */
      patternColor: {default: '${COLOR}'},
      patternTitle: {default: '${NAME}'},
      patternClub: {default: '${CLUB}'}
      /* eslint-enable no-template-curly-in-string */
    }),
    dataset () {
      if (!this.datasetId) return null
      return this.$store.getters.dataset(this.datasetId)
    },
    datasetColumns () {
      if (!this.dataset) return
      return this.dataset.columns || []
    }
  },
  watch: {
    recordId1: function (val) {
      if (!val) return
      let record = this.$store.getters.dataset(this.datasetId).records
        .find(r => r.recordId === val)
      if (!record) return
      record = this.mapRecord(record)
      this.color1 = record.color || this.color1
      this.title1 = record.title
      this.club1 = record.club
    },
    recordId2: function (val) {
      if (!val) return
      let record = this.$store.getters.dataset(this.datasetId).records
        .find(r => r.recordId === val)
      if (!record) return
      record = this.mapRecord(record)
      this.color2 = record.color || this.color2
      this.title2 = record.title
      this.club2 = record.club
    }
  },
  methods: {
    mapRecord (record) {
      const result = {}
      const recordMap = {
        color: this.patternColor,
        title: this.patternTitle,
        club: this.patternClub
      }
      for (let k in recordMap) {
        if (!recordMap.hasOwnProperty(k)) continue
        result[k] = recordMap[k].replace(/\$\{([\w ]+)\}/g, function (match, p1) {
          return record[p1] || ''
        })
      }
      return result
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/boxing-duel.vue